import { Box, Button, ButtonGroup, Grid2 as Grid, TextField } from "@mui/material"
import { useState } from "react"
import { globalstyles } from '../lib/definitions';
import { MyInput } from './MyInput';


const personal_data_entry = [
    { id: 'firstname', label: 'Nome' },
    { id: 'lastname', label: 'Cognome' },
    { id: 'note', label: 'note' },
    { label: 'data di nascita', id: 'birthdate', type: 'date', advance: true },
    { id: 'birthplace', label: 'luogo di nascita', advance: true },
    { id: 'address_street', label: 'Residenza (via)', advance: true },
    { id: 'address_city', label: 'città', advance: true },
    { id: 'address_state', label: 'Provincia', advance: true },
    { id: 'address_nation', label: 'Nazione', advance: true },
]
const location_data_entry = [
    { id: 'name', label: 'Nome'},
    { id: 'address_street', label: 'via', advance: true },
    { id: 'address_cap', label: 'cap', advance: true },
    { id: 'address_city', label: 'città', advance: true },
    { id: 'address_state', label: 'Provincia', advance: true },
    { id: 'address_state_short', label: 'Provincia (ridotto)', advance: true },
    { id: 'address_nation', label: 'Nazione', advance: true },
]

export const PersonalDataForm = ({ curElement, setCurElement, section_title , type} ) => {
    const [showAdvance, setShowAdvance] = useState(false)
    const onChangeHandler = (el, level) => {
        let { name, value, type } = el
        console.log("PD", el)
        console.log("PD",name, value, type)
        if (type === 'radio') {
            if (value === 'true') {
                value = true
            } else if (value === 'false') {
                value = false
            }
        } else if (type === 'checkbox') {
            value = el.checked

        }
        if (value !== undefined) {
            setCurElement({ ...curElement, [name]: value })
        }
    }
    const pdata = type==='address'?location_data_entry: personal_data_entry

    return (
        <Grid sx={globalstyles.list_container}>
            <Grid sx={{fontSize:'1.2em', fontWeight:'bold'}} container>
                <Grid size="grow">

                {section_title}
                </Grid>
                <Grid>
                <ButtonGroup size="small">
                    <Button color="secondary" variant={!showAdvance ? 'contained' : 'outlined'} onClick={() => setShowAdvance(false)}>inserimento dati semplice</Button>
                    <Button color="secondary" variant={showAdvance ? 'contained' : 'outlined'} onClick={() => setShowAdvance(true)}>avanzato</Button>
                </ButtonGroup>
                </Grid>
            </Grid>
            {pdata.filter(p => (showAdvance || !p.advance)).map((p, pk) => (
                <MyInput 
                    key={pk}
                    id={p.id}
                    label={p.label}

                    type={p.type}
                    value={curElement ? curElement[p.id] : ''}
                    onChange={(ev) => onChangeHandler(ev.target)}
                />
            ))}

        </Grid>
    )
}
